module.exports = __webpack_public_path__ + "static/SkeltonLogo-8e3269f75ea599597cd702b1f1498d79.svg";